'use strict';

const CONSENT_COOKIE_NAME = 'cookie_consent'
const CONSENT_COOKIE_PATTERN = /(?:^|;\s*)cookie_consent\s*=\s*([^;]*)/
const YEAR_IN_MS = 1000 * 60 * 60 * 24 * 365
const RECAPTCHA_EVENT = 'swisstime:recaptcha-ready'

function setCookieConsent(value) {
    const expires = new Date(Date.now() + YEAR_IN_MS).toUTCString()
    document.cookie = `${CONSENT_COOKIE_NAME}=${value}; expires=${expires}; SameSite=Lax; path=/`
}

function getCookieConsent() {
    const match = document.cookie.match(CONSENT_COOKIE_PATTERN)
    return match ? match[1] : null
}

/**
 * Проверяет, что все перечисленные категории разрешены:
 * либо согласие 'all', либо каждая категория входит в значение cookie.
 */
function hasConsentFor(requiredCategories) {
    const consent = getCookieConsent() || ''
    if (consent === 'all') return true
    const granted = consent.split(',').map((cat) => cat.trim())
    return requiredCategories.split(',').every((cat) => granted.indexOf(cat.trim()) !== -1)
}

/**
 * Показывает/скрывает блок политик reCAPTCHA в зависимости от того,
 * выдано ли согласие на категорию 'analytics'.
 */
function applyRecaptchaPolicies() {
    const accepted = hasConsentFor('analytics')
    document.querySelectorAll('[data-recaptcha-policies]').forEach((el) => {
        el.style.display = accepted ? '' : 'none'
    })
}

/**
 * Активирует или блокирует скрипты с атрибутом data-cookie:
 * исполняемые получают type="text/javascript", заблокированные — "text/plain".
 */
function applyConsent() {
    document.querySelectorAll('[data-cookie]').forEach((el) => {
        const ok = hasConsentFor(el.getAttribute('data-cookie'))

        const replacement = document.createElement('script')
        for (let i = 0; i < el.attributes.length; i++) {
            const attr = el.attributes[i]
            if (attr.name !== 'type' && attr.name !== 'data-cookie') {
                replacement.setAttribute(attr.name, attr.value)
            }
        }
        replacement.type = ok ? 'text/javascript' : 'text/plain'
        if (el.src) {
            replacement.src = el.src
        } else {
            replacement.textContent = el.textContent
        }
        if (replacement.src && replacement.src.indexOf('recaptcha') !== -1) {
            replacement.addEventListener('load', () => {
                document.dispatchEvent(new CustomEvent(RECAPTCHA_EVENT))
            })
        }
        el.parentNode.replaceChild(replacement, el)
    })
    applyRecaptchaPolicies()
}

export { setCookieConsent, getCookieConsent, hasConsentFor, applyConsent, applyRecaptchaPolicies }
